import React from 'react';
import { Card, Col, H2, NavButtonLink, Row } from '../../Elements';
import {
    CanViewGuniteJobAll,
    CanViewMobileMap,
    CanViewMobileSearch,
    CanViewMyJobs,
    CanViewPlasterJobsAll,
    CanViewWarrantyJobs
} from '../Auth';
import { JobQuickSearch } from '../Job';
import { useHasRight } from "../../Hooks/hasRight";
import { CAN_VIEW_MOBILE_MAP, CAN_VIEW_MY_JOBS } from "../../utils/enums";

const baseButtonStyle = {
    margin: '1em',
    width: '80%',
    height: '80%'
}

const supervisorDashBoardRightButtonStyle = {
    ...baseButtonStyle,
    marginLeft: '.5em'
}

const supervisorDashBoardLeftButtonStyle = {
    ...baseButtonStyle,
    marginRight: '.5em'
}

const insiteTextStyle = {
    display: 'inline',
    fontFamily: 'Rockwell',
    textDecoration: 'underline',
    fontStyle: 'italic'
}

const SupervisorDashBoardButton = ({ text, icon, to, onRight = false }) => {
    return <NavButtonLink
        large
        to={to}
        text={text}
        icon={icon}
        intent='primary'
        style={onRight ? supervisorDashBoardRightButtonStyle : supervisorDashBoardLeftButtonStyle}
        minimal={false}
    />
}

export const SupervisorDashboard = () => {
    const isMyJobsVisible = useHasRight(CAN_VIEW_MY_JOBS)
    const isSupervisorMapVisible = useHasRight(CAN_VIEW_MOBILE_MAP)

    return <Row>
        <Col xs={12} lg={8} lgOffset={2}>
            <Card style={{ textAlign: 'center' }}>
                <H2 className='color' style={{ display: 'inline' }}>Welcome to </H2>
                <H2 className='color' style={insiteTextStyle}> Insite</H2>

                <CanViewMobileSearch>
                    <JobQuickSearch />
                </CanViewMobileSearch>


                {(isMyJobsVisible || isSupervisorMapVisible) &&
                    <Row>
                        <CanViewMyJobs>
                            <Col xs={isSupervisorMapVisible ? 6 : 12}>
                                <SupervisorDashBoardButton
                                    icon='time'
                                    text='My Jobs'
                                    to='/Schedule'
                                />
                            </Col>
                        </CanViewMyJobs>
                        <CanViewMobileMap>
                            <Col xs={isMyJobsVisible ? 6 : 12}>
                                <SupervisorDashBoardButton
                                    text='Map'
                                    icon='globe'
                                    to='/Supervisor/Map'
                                    onRight
                                />
                            </Col>
                        </CanViewMobileMap>
                    </Row>
                }
                <CanViewGuniteJobAll>
                    <Row>
                        <Col xs={6}>
                            <SupervisorDashBoardButton
                                text='Gunite Day Schedule'
                                icon='symbol-square'
                                to='/day/gunite'
                            />
                        </Col>
                        <Col xs={6}>
                            <SupervisorDashBoardButton
                                text='Gunite Week'
                                icon='grid-view'
                                to='/week/gunite'
                                onRight
                            />
                        </Col>
                    </Row>
                </CanViewGuniteJobAll>

                <CanViewPlasterJobsAll>
                    <Row>
                        <Col xs={6}>
                            <SupervisorDashBoardButton
                                text='Pebble Day Schedule'
                                icon='flash'
                                to='/day/pebble'
                            />
                        </Col>
                        <Col xs={6}>
                            <SupervisorDashBoardButton
                                text='Pebble Week'
                                icon='new-grid-item'
                                to='/week/pebble'
                                onRight
                            />
                        </Col>
                    </Row>
                </CanViewPlasterJobsAll>
                <CanViewWarrantyJobs>
                    <Row>
                        <Col xs={6}>
                            <SupervisorDashBoardButton
                                text='Warranty Day Schedule'
                                icon='vertical-distribution'
                                to='/day/warranty'
                            />
                        </Col>
                        <Col xs={6}>
                            <SupervisorDashBoardButton
                                text='Warranty Week'
                                icon='panel-table'
                                to='/week/warranty'
                                onRight
                            />
                        </Col>
                    </Row>
                </CanViewWarrantyJobs>
            </Card>
        </Col>
    </Row>
}